export default "__VITE_ASSET__CnWXPHZ2__"